import { Typography, Box, useTheme, TextField, Divider, Autocomplete, Button, Grid, TableBody, Dialog, DialogTitle, DialogContent, DialogActions, TableContainer, Table, TableHead, TableRow, TableCell } from "@mui/material";
import React, { useState, useEffect } from "react";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import SkeletonTableLoader from "../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../components/table/CustomTableContainer";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const AddTDS = ({ onClose, handleBackWinderMachineEntry, open }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const [operatorList, setOperatorList] = useState([]);
    const [result, setresult] = useState([]);
    const [description, setDescription] = useState('');
    const [selectedID, setSelectedID] = useState(0);

    const [operatorEmailID, setOperatorEmailID] = useState('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [status, setStatus] = useState('Active');
    const [loading, setLoading] = useState(false);

    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const OperatorColumns = [
        { field: "id", headerName: "SNo", hide: true, flex: 1, cellClassName: "name-column--cell" },
        { field: "description", headerName: "Description", flex: 1, cellClassName: "name-column--cell" },
        { field: "status", headerName: "Status", flex: 2, cellClassName: "name-column--cell" },
    ];


    const statusTypeOptions = [
        { id: 1, label: "Active" },
        { id: 2, label: "In-Active" },
    ];

    const callback = () => {
        handleBackWinderMachineEntry();
    };

    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {

            fetchTDS();
        }
    }, [isDataLoaded]);


    const fetchTDS = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
        }
        callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_TDS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setOperatorList(data);
                    // setSelectedTDS(data[0]);

                }
            })
            .catch(error => {
                // Update state with error message        
                alert(error.message);
                // 

            });
    }

    const handleClear = () => {
        setDescription('');
        setSelectedID(0);
        setStatus('Available')
    }


    const handleSaveOperator = () => {

        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (description === '') {
            validation_msg += 'Please enter description value.\n';
            isValid = false;
        }


        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_description: description,
                p_status: status,
                p_mode: selectedID === 0 ? 0 : 1,
                p_id_tds: selectedID,
            }

            callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_CRUD_TDS, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {


                        fetchTDS();
                        
                        if (selectedID === 0) {
                            toast.success('New TDS Added Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else {
                            toast.success('New TDS Updated Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                        }





                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }


    };

    const handleEdit = (id_tds, description, currentstatus) => {
        setDescription(description);
        setStatus(currentstatus);
        setSelectedID(id_tds);
    };



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    <Typography>Add TDS</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 1 }} >
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Description </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={description} onChange={(e) => setDescription(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>
                                </Box>
                            </Box>
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}

                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Status</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        options={statusTypeOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={
                                            statusTypeOptions.find((opt) => opt.label === status) || null
                                        }
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                setStatus(newValue.label);
                                            } else {
                                                setStatus('');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="" />
                                        )}
                                    />
                                </Box>
                            </Box>



                            <Box marginTop={5}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button onClick={handleClear} sx={{ marginRight: "10px" }} size="small" variant="contained" color="secondary">
                                        Clear
                                    </Button>
                                    <Button onClick={handleSaveOperator} size="small" variant="contained" color="secondary">
                                        Save
                                    </Button>
                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />

                            <Box marginTop={1}>
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        {loading ? (
                                            <SkeletonTableLoader rows={5} columns={6} />
                                        ) : (
                                            <Table>
                                                <TableHead sx={{ height: 10 }}>
                                                    <TableRow>
                                                        <TableCell>NO</TableCell>
                                                        <TableCell>DESCRIPTION</TableCell>
                                                        <TableCell>STATUS</TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {operatorList.map((s) => (
                                                        <React.Fragment key={s.id}>
                                                            <TableRow>
                                                                <TableCell>{s.id}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleEdit(s.id, s.description, s.status)}
                                                                    >
                                                                        {s.description}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{s.status}</TableCell>

                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                </TableBody>
                                            </Table>
                                        )}
                                    </TableContainer>
                                </CustomTableContainer>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>

                <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddTDS;